import React from 'react';
import { Dialog, DialogContent, Box, Typography, Button, Paper, IconButton, useMediaQuery, useTheme } from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import StarsIcon from '@material-ui/icons/Stars';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import CloseIcon from '@material-ui/icons/Close';

const FriendlyTrialExpiredModal = ({ open, onClose, onOpenCheckout, whatsappSupport = '5538998588893' }) => {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));

  const handleWhatsAppClick = () => {
    const text = encodeURIComponent('Olá! Meu período de testes do Duzz Commercial venceu e gostaria de ajuda para escolher meu plano de assinatura.');
    window.open(`https://wa.me/${whatsappSupport}?text=${text}`, '_blank');
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        style: {
          borderRadius: 20,
          padding: 8,
          position: 'relative'
        },
      }}
    >
      {onClose && (
        <IconButton
          onClick={onClose}
          style={{
            position: 'absolute',
            top: 12,
            right: 12,
            color: '#94a3b8',
          }}
          title="Fechar"
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      )}

      <DialogContent style={{ padding: isDesktop ? 32 : 20, textAlign: 'center' }}>
        {/* Header Icon Badge */}
        <Box display="flex" justifyContent="center" mb={2}>
          <Box
            style={{
              width: 72,
              height: 72,
              borderRadius: '50%',
              backgroundColor: '#eff6ff',
              color: '#2563eb',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 8px 20px -4px rgba(37, 99, 235, 0.25)',
            }}
          >
            <StarsIcon style={{ fontSize: 42 }} />
          </Box>
        </Box>

        <Typography variant="h5" style={{ fontWeight: 800, color: '#0f172a', marginBottom: 8, lineHeight: 1.3 }}>
          Sua degustação gratuita chegou ao fim! 🚀
        </Typography>

        <Typography variant="body1" style={{ color: '#475569', marginBottom: 24, lineHeight: 1.5 }}>
          Esperamos que você tenha aproveitado estes dias de teste no <strong>Duzz Commercial</strong>.
          Seus dados, produtos e histórico estão 100% preservados e prontos para continuar!
        </Typography>

        {/* Benefits Card */}
        <Paper
          elevation={0}
          style={{
            backgroundColor: '#f8fafc',
            border: '1px solid #e2e8f0',
            borderRadius: 14,
            padding: 16,
            marginBottom: 24,
            textAlign: 'left',
          }}
        >
          <Box display="flex" alignItems="flex-start" mb={1.5} style={{ gap: 10 }}>
            <CheckCircleIcon style={{ color: '#10b981', fontSize: 20, marginTop: 2 }} />
            <Typography variant="body2" style={{ color: '#334155', fontWeight: 600 }}>
              Seus cadastros, estoque e vitrine virtual estão guardados com total segurança.
            </Typography>
          </Box>
          <Box display="flex" alignItems="flex-start" mb={1.5} style={{ gap: 10 }}>
            <CheckCircleIcon style={{ color: '#10b981', fontSize: 20, marginTop: 2 }} />
            <Typography variant="body2" style={{ color: '#334155', fontWeight: 600 }}>
              Ativação instantânea assim que escolher o plano ideal para sua empresa.
            </Typography>
          </Box>
          <Box display="flex" alignItems="flex-start" style={{ gap: 10 }}>
            <CheckCircleIcon style={{ color: '#10b981', fontSize: 20, marginTop: 2 }} />
            <Typography variant="body2" style={{ color: '#334155', fontWeight: 600 }}>
              Suporte especializado via WhatsApp para ajudar você em todas as etapas.
            </Typography>
          </Box>
        </Paper>

        <Box display="flex" flexDirection="column" style={{ gap: 12 }}>
          <Button
            variant="contained"
            color="primary"
            size="large"
            fullWidth
            onClick={onOpenCheckout}
            style={{
              backgroundColor: '#17497F',
              color: '#ffffff',
              fontWeight: 800,
              borderRadius: 12,
              padding: '14px 24px',
              textTransform: 'none',
              fontSize: 16,
              boxShadow: '0 8px 20px -4px rgba(23, 73, 127, 0.4)',
            }}
          >
            Escolher Plano e Assinar Agora
          </Button>

          <Button
            variant="outlined"
            size="medium"
            fullWidth
            onClick={handleWhatsAppClick}
            startIcon={<WhatsAppIcon style={{ color: '#16a34a' }} />}
            style={{
              borderRadius: 12,
              borderColor: '#cbd5e1',
              color: '#334155',
              fontWeight: 700,
              textTransform: 'none',
              padding: '10px 20px',
            }}
          >
            Falar com um Consultor no WhatsApp
          </Button>

          {onClose && (
            <Button
              variant="text"
              size="small"
              fullWidth
              onClick={onClose}
              style={{
                color: '#64748b',
                fontWeight: 600,
                textTransform: 'none',
                marginTop: 4,
              }}
            >
              Continuar no sistema
            </Button>
          )}
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default FriendlyTrialExpiredModal;
